import IconLoader from "@/features/Common/components/IconLoader";
import { Button, Stack } from "@mui/material";
import WellnessCategoryCard from "../WellnessCategoryCard";
import { useTranslation } from "react-i18next";
import {
  WellnessCategoryCardProps,
  WellnessScoreStatus,
} from "../Common/types";
import { useNavigate } from "react-router";

export default function MentalWellbeingCard() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const mentalWellbeingProps: WellnessCategoryCardProps = {
    icon: (
      <IconLoader
        icon="MentalWellbeingIcon"
        color="primary"
        sx={{ fontSize: 40 }}
      />
    ),
    title: "Mental Wellbeing",
    status: undefined,
    description: t("MentalWellbeing.description"),
    lastUpdated: "",
  };

  return (
    <WellnessCategoryCard {...mentalWellbeingProps}>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          navigate("/home/health-score/mental-wellbeing-questionnaire")
        }
        fullWidth
      >
        {t("MentalWellbeing.buttonLabel.primary")}
      </Button>
    </WellnessCategoryCard>
  );
}
